<app-page-header subtitle="OrderDirect Inkoopfactuur Detail"> </app-page-header>

<div class="text-container">
    @if (loading) {
        <div class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Laden...</span>
            </div>
        </div>
    }

    @if (!loading && invoice) {
        <div class="row mb-4">
            <div class="col-md-24">
                <div class="d-flex justify-content-between align-items-center">
                    <button (click)="goBack()" mat-raised-button><i class="fas fa-arrow-left"></i> Terug</button>
                    <h3>Inkoopfactuur (Boekstuknummer): {{ invoice.od_bon_nr }}</h3>
                    @if (canSendToAfas()) {
                        <button class="btn btn-primary" (click)="sendToAfas()">
                            <i class="fas fa-paper-plane"></i> Naar AFAS verzenden
                        </button>
                    }
                    <button class="btn btn-warning" (click)="resetStatus()">
                        <i class="fas fa-undo"></i> Status resetten
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card mb-4">
                    <div class="card-header">
                        <h5>Algemene informatie</h5>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm">
                            <tbody>
                                <tr>
                                    <th>ID:</th>
                                    <td>{{ invoice.id }}</td>
                                </tr>
                                <tr>
                                    <th>Bonnummer:</th>
                                    <td>{{ invoice.od_bon_nr }}</td>
                                </tr>
                                <tr>
                                    <th>Boekstuknummer:</th>
                                    <td>{{ invoice.od_inkfak_nr || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>BTW datum:</th>
                                    <td>{{ invoice.od_invoer_dat | date: 'EEE d MMM yyyy' }}</td>
                                </tr>
                                <tr>
                                    <th>Crediteur nummer:</th>
                                    <td>{{ invoice.od_cred_nr || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>Crediteur naam:</th>
                                    <td>{{ invoice.od_cred_naam || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>Prijs inkoop:</th>
                                    <td>{{ invoice.od_prijs_ink | currency: 'EUR' : 'symbol' : '1.2-2' }}</td>
                                </tr>
                                <tr>
                                    <th>AFAS Creditor ID:</th>
                                    <td>{{ invoice.afas_creditor_id || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div class="card mb-4">
                    <div class="card-header">
                        <h5>AFAS & Status</h5>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm">
                            <tbody>
                                <tr>
                                    <th>Status:</th>
                                    <td>
                                        <span
                                            class="badge"
                                            [ngClass]="getStatusClass(invoice | orderdirectPurchaseInvoiceStatus)">
                                            {{ getStatusLabel(invoice | orderdirectPurchaseInvoiceStatus) }}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>AFAS Order Nr:</th>
                                    <td>{{ invoice.afas_ornu || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>AFAS Factuurnummer:</th>
                                    <td>{{ invoice.afas_liin || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>Uitgevoerd op:</th>
                                    <td>{{ invoice.execute_at | date: 'EEE d MMM yyyy HH:mm' }}</td>
                                </tr>
                                <tr>
                                    <th>Mislukt op:</th>
                                    <td>{{ invoice.failed_at | date: 'EEE d MMM yyyy HH:mm' }}</td>
                                </tr>
                                <tr>
                                    <th>Aangemaakt:</th>
                                    <td>{{ invoice.created_at | date: 'EEE d MMM yyyy HH:mm' }}</td>
                                </tr>
                                <tr>
                                    <th>Bijgewerkt:</th>
                                    <td>{{ invoice.updated_at | date: 'EEE d MMM yyyy HH:mm' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        @if (invoice.exception) {
            <div class="row">
                <div class="col-md-24">
                    <div class="card mb-4">
                        <div class="card-header bg-danger text-white">
                            <h5>Foutmelding</h5>
                        </div>
                        <div class="card-body">
                            <pre class="text-danger mb-0">{{ invoice.exception }}</pre>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (jsonData) {
            <div class="row">
                <div class="col-md-24">
                    <div class="card mb-4">
                        <div class="card-header">
                            <h5>JSON Data</h5>
                        </div>
                        <div class="card-body">
                            <pre class="json-data">{{ jsonData | json }}</pre>
                        </div>
                    </div>
                </div>
            </div>
        }
    }
</div>
